<template>
  <section class="flex">
    <CommonDocumentMain :prefix-path="`/${$route.params.lang}/docs`" />
  </section>
</template>
<script lang="ts" setup>
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-detail-page-cache-tag'])
})
definePageMeta({
  pageTransition: {
    name: '',
    mode: 'out-in'
  }
})
const route = useRoute()
const documentStore = useDocumentStore()
const { fetchDocumentDetail } = documentStore
await fetchDocumentDetail(route.params.id as string)
</script>
